import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faMinusSquare } from '@fortawesome/free-solid-svg-icons';
import { RootState, useDispatch, useSelector } from '../../redux/store';
import { setDialogMode, openDialog, setConditionOrdinary } from '../../redux/slices/condition';
import type { ICellRendererParams } from 'ag-grid-community';
import type { ConditionDetailType } from '../../types/condition';

const ActionsManageCondition = (params: ICellRendererParams) => {
  const dispatch = useDispatch();
  const { condition, selectedViewMode } = useSelector((state: RootState) => state.condition);
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [isDeletable, setIsDeletable] = useState<boolean>(false);
  const data: ConditionDetailType = params.data;

  // SIDE EFFECT
  // ================================================================================

  /**
   * 確認用
   */
  // useEffect(() => {
  //   console.log(data);
  // }, []);

  // 編集可能な状態かをチェックする
  useEffect(() => {
    if (selectedViewMode === 'EDITING' && (condition?.conditionStatus === 'EDITING' || condition?.conditionStatus === 'APPROVED')) {
      setIsEditable(true);
      setIsDeletable(true);
    } else {
      setIsEditable(false);
      setIsDeletable(false);
    }
  }, [selectedViewMode, condition?.conditionStatus]);

  // EVENT HANDLER
  // ================================================================================

  /**
   * Editボタンを押した時
   */
  const handleUpdateRow = (): void => {
    // console.log(params)
    if (isEditable) {
      dispatch(setConditionOrdinary(data.id));
      dispatch(setDialogMode('UPDATE'));
      dispatch(openDialog());
    }
  };

  /**
   * Deleteボタンを押した時
   */
  const handleDeleteRow = (): void => {
    // console.log(params)
    if (isDeletable) {
      dispatch(setConditionOrdinary(data.id));
      dispatch(setDialogMode('DELETE'));
      dispatch(openDialog());
    }
  };

  // VIEW
  // ================================================================================

  return (
    <>
      <div id="editActions">
        <>
          <FontAwesomeIcon
            className="mr-3"
            icon={faEdit}
            size="lg"
            color={isEditable ? '#007bff' : '#ccc'}
            onClick={handleUpdateRow}
            style={isEditable ? { cursor: 'pointer' } : { cursor: 'default' }}
          />
          <FontAwesomeIcon icon={faMinusSquare} size="lg" color={isDeletable ? '#c4183c' : '#ccc'} onClick={handleDeleteRow} style={isDeletable ? { cursor: 'pointer' } : { cursor: 'default' }} />
        </>
      </div>
    </>
  );
};

export default ActionsManageCondition;
